module.exports = __webpack_public_path__ + "img/icon_yishenqinghui.df7f58c9.svg";